import { PipeTransform, Pipe } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
	name: 'dateFormat'
})
export class DateFormat implements PipeTransform {
	transform(value: any, format?: string, locale?: string) : string {
		if ( ! value) return '';
		
		return moment(value).locale(locale || 'ru').format(format || 'DD.MM.YYYY');
	}
}


@Pipe({
	name: 'dateTimeFormat'
})
export class DateTimeFormat implements PipeTransform {
	transform(value: any, format?: string, locale?: string) : string {
		if ( ! value) return '';

		return moment(value).locale(locale || 'ru').format(format || 'YYYY-MM-DD HH:mm:ss');
	}
}


@Pipe({
	name: 'dateDiff'
})
export class DateDiff implements PipeTransform {
	transform(date1: any, date2, format: string = 'days', locale?: string): string {
		if ( ! date1) return '';
		if ( ! date2) return '';
		
		return moment(date1).locale(locale || 'ru').diff(date2, format);
	}
}
